/**
 * Copyright ©2024 Drivepoint
 */

import {Logger} from "@bainbridge-growth/node-frontend";
import Firebase from "@services/firebase/Firebase";

// required for any libraries that need window.global, since Vite doesn't provide it (Joyride, for example)
declare global { interface Window {global: any} }
window.global ||= window;

// declare "logger" to be a global
declare global { interface Window {logger: Logger} }
declare global { let logger: Logger; }
window.logger ||= Logger.logger;

// start Logger
Logger.start();

declare global { interface Window {_firebase: typeof Firebase} }
window._firebase ||= Firebase;

export {};
